<div class="cert-details">
    <!-- TREE VIEW -->
    @if(detailType === 'tree' && vcTreeData && vcTreeData.length > 0) {
    <div>
        <app-certification-template-tree-viewer [nodes]="vcTreeData"></app-certification-template-tree-viewer>
    </div>
    }

    <!-- RAW JSON VIEW -->
    @if(detailType === 'raw') {
    <div class="raw-jwt-details">
        <div class="jwt-pre-container">
            <pre>{{ certificate.getRawJson() | json }}</pre>
        </div>
    </div>
    }
    @if(!detailType) {
    <div>
        <app-certification-template-tree-viewer [nodes]="certificate.getTreeData()">
        </app-certification-template-tree-viewer>
    </div>
    }

    @if(isAuth) {
    <div class="detail-actions">
        @if(detailType) {
        <app-span-button [label]="detailType === 'tree'? 'Rohdaten anzeigen' : 'Baumansicht anzeigen'" 
            (click)="toggleViewMode()">
        </app-span-button>
        }
    </div>
    }
</div>
